<template>
  <div id="sell">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'sell',
  };
</script>



// WEBPACK FOOTER //
// Sell.vue?4ddd1ea7